import axios from "axios";
import Swal from "sweetalert2";
import config from "../utils/config";

async function apiService({
  url,
  methodType,
  body,
  extra,
  params,
  backgroundService,
}) {
  return Promise.resolve().then((v) =>
    axios({
      method: methodType,
      url: `${!url.includes("http") ? config.baseUrl() : ""}${url}`,
      data: body,
      params: {
        client: window.Android ? "android" : "web",
        ...params,
      },
      headers: {
        Authorization: extra?.token
          ? extra.token
          : localStorage.getItem(`token`),
      },
    })
      .then((res) => {
        if (res.data && res.data.token) {
          localStorage.setItem("token", res.data.token);
        }
        if (res.data.success == 0) {
          Swal.fire({
            text: res.data.description,
            icon: "warning",
            confirmButtonText: "تایید",
          });
        }
        if (res.data.success === 2) {
          if (res.data && res.data.msg === "low balance" && res.data.url) {
            if (window.Android) {
              window.Android.openPaymentLink(res.data.url);
            } else {
              window.location.href = res.data.url;
            }
          }
        }
        return res.data;
      })
      .catch((err) => {
        if (
          err &&
          err.response &&
          (err.response.status === 401 || err.response.status === 403)
        ) {
          return err.response;
        }
        if (err && err.response && err.response.status === 500) {
          Swal.fire({
            icon: "error",
            text: "خطایی رخ داده است با پشتیبانی تماس بگیرید",
            confirmButtonText: "تایید",
          });
        }
        console.log(err);
      })
  );
}
export { apiService };
